const landing_page = {
  aboutUs: "À propos de nous", // translated
  topPackages: "Meilleurs forfaits", // translated
  featuredHotels: "Hôtels en vedette", // translated
  topTours: "Meilleures visites", // translated
  whatOurMembersSay: "Ce que disent nos membres...", // translated
  followUsOnInstagram: "Suis nous sur instagram", // translated
  pleaseWait: "S'il vous plaît, attendez...", // translated
  packages: "Paquets", // translated
  ourPartners: "Nos partenaires", // translated
  learnMore: "Apprendre encore plus", // translated
  trustedCarHirePartners: "Partenaires de location de voitures de confiance", // translated
};


export default landing_page;
